<template>
  <b-modal
    v-model="inputVal"
    :id="id"
    :title="title"
    hide-footer
    @show="getPayaUrl">
    <!-- we set it conditionally visible so it is remounted each time -->
    <paya-payment-account @card-added="cardAdded"/>
  </b-modal>
</template>


<script>
import PayaPaymentAccount from "../PayaPaymentAccount.vue";
import { BModal } from "bootstrap-vue";

export default {
  components: {
    BModal,
    PayaPaymentAccount},

  data () {
    return {
      title: "Add credit card",
      form_data: null
    }
  },

  props: {
    id: {
      required: true,
      type: String
    },
    accountName: {
      required: false,
      type: String,
      default: ''
    },
    value : {
      required: false,
      type: Boolean,
      default: false
    }
  },

  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        if (!val) {
          this.$emit('hide');
        }
      }
    }
  },

  methods : {
    getPayaUrl () {
      this.$store.dispatch('getPayaUrl', this.accountName);
    },
    cardAdded (card_data) {
      this.form_data = card_data;
      this.$emit('card-added', this.form_data);
      this.$root.$emit('bv::hide::modal', this.id);
    },
  },
}
</script>



// WEBPACK FOOTER //
// NewPayaPaymentAccountModal.vue?121b960a